import React, { Fragment, useContext, useState } from "react";
import DashPage from "../dash/DashPage";
import TabbedView from "../../components/lists/TabbedView/TabbedView";
import styles from "./styles";
import TabbedViewPage from "../../components/lists/TabbedView/TabbedViewPage";
import { WalkaroundManager } from "./wa_manager/WalkaroundManager";
import { WalkaroundCheckListManager } from "./wa_checklist/WaCheckListManager";
import { WaOptions } from "./wa_options/WaOptions";
import NotFoundPage from "../error/NotFoundPage";
import { SessionContext } from "../../utility/useSession";
import { WaReports } from "./wa_reports/WaReports";
import { isAdmin } from "../../utility/utils";
import { useTranslation } from "react-i18next";
import { WaDefects } from "./wa_defects/WaDefects";

const WalkaroundsPage: React.FC = () => {
    const session = useContext(SessionContext);
    const { t } = useTranslation();
    const [noScroll, setNoScroll] = useState(true);
    if (session?.current?.site?.preferences.bus_walkaround_enabled != true) {
        return <NotFoundPage title={t("notFoundPage.notAvailable")} message={t("notFoundPage.featureNotEnabled")} />
    }
    return (
        <DashPage noScroll={noScroll}>
            <Fragment>

                <div style={{ padding: 20 }}>
                    <div style={{ textAlign: "center" }}>
                        <div style={{ padding: 20, marginBottom: 20 }}>
                            <div><span style={styles.title}>{t("menuItems.busWalkarounds")}</span></div>
                        </div>
                        <div style={{ paddingLeft: 50, paddingRight: 50, paddingBottom: 50 }}>
                            <TabbedView selectedIndex={0} onSelectedIndexChange={(i) => {
                                setNoScroll(i == 0);
                            }}>
                                <TabbedViewPage title={t('walkarounds.busReports')}>
                                    <WaReports />
                                </TabbedViewPage>
                                <TabbedViewPage title={t('walkarounds.busDefects')}>
                                    <WaDefects />
                                </TabbedViewPage>
                                <TabbedViewPage title={t("walkarounds.checklists")} visible={isAdmin(session)}>
                                    <WalkaroundCheckListManager />
                                </TabbedViewPage>
                                <TabbedViewPage title={t("walkarounds.title")} visible={isAdmin(session)}>
                                    <WalkaroundManager />
                                </TabbedViewPage>
                                <TabbedViewPage title={t("reports.content")} visible={isAdmin(session)}>
                                    <WaOptions />
                                </TabbedViewPage>
                            </TabbedView>
                        </div>
                    </div>
                </div>
            </Fragment>
        </DashPage>
    );
};

export default WalkaroundsPage;